import React, {PureComponent} from 'react';
import {
    View,
    StyleSheet,
    Clipboard
} from 'react-native';
import {
    JDText,
    JDImage,
    JDTouchable,
    JDLogin
} from '@jdreact/jdreact-core-lib';

import { pt, px, fy_mta, tip } from '../../../common/utils';
import { fy_post } from '../../../common/fetch';
import sgmReport from '../../../common/sgmUtil';

import CouponDetail from './coupon-detail';

class OrderCoupon extends PureComponent {
    state = {isDetailShow: false, activeGoodsCoupon: [], currentCoupon: null}
    _closeDialog() {
        this.setState({
            isDetailShow: false
        })
    }
    _openDialog(couponItem) {
        let eventId = 'LifeTravelSys_PackDiscountDetail';
        let eventParam = couponItem.activeId + '_' + couponItem.activeOrderGoodsCouponDTO.couponName;
        fy_mta(eventId, eventParam);
        this.setState({
            currentCoupon: couponItem,
            isDetailShow: true
        });
    }
    _copyCard(text) {
        try {
            Clipboard.setString(text);
        } catch(e) {
            tip('复制失败');
        }
        tip('复制成功');
    }
    
    componentDidMount() {
        this.getFYOrderDetail();
    }
    getFYOrderDetail() {
        const { erpOrderId } = this.props;
        fy_post(`assistincome_sc_get_order_info`, {
            businessCode: 43,
            businessOrderCode: erpOrderId
        }).then(res => {
            if (res.body && res.body.length) {
                let list = [];
                res.body.forEach(value => {
                    if (value.orderStatus === 3) {
                        list.push(value);
                    }
                });
                this.setState({
                    activeGoodsCoupon: list
                });
            }
        });

        if(!erpOrderId){
            sgmReport('1001', {function_id: 'assistincome_sc_get_order_info',message:'缺少参数erpOrderId'}, 3)
        }
    }
    render() {
        const { isDetailShow, activeGoodsCoupon, currentCoupon } = this.state;
        return (
            activeGoodsCoupon.length>0 && <View style={[st.box]}>
                <View style={[st.title]}><JDText style={[st.t_txt]}>特价优惠</JDText></View>
                {
                    activeGoodsCoupon.map((couponItem, index) => {
                        return (
                            <View style={[st.coupon]} key={index} style={{borderBottomColor: "#E6E6E6", borderBottomWidth: px(1), marginLeft: pt(12), marginRight: pt(12)}}>
                                <View style={[st.coupon_item]}>
                                    <View style={[st.coupon_l]}>
                                        <View style={[st.zeng]}><JDText style={[st.z_txt]}>赠</JDText></View>
                                        <JDText style={[st.coupon_txt]}>{couponItem.activeOrderGoodsCouponDTO.couponName}</JDText>
                                        <JDTouchable onPress={() => this._openDialog(couponItem)}><JDImage style={[st.icon]} source={img.coupon_detail_icon} /></JDTouchable>
                                    </View>
                                    <View><JDText style={[st.money_txt]}>{couponItem.activeOrderGoodsCouponDTO.amount}元</JDText></View>
                                </View>
                                {
                                    couponItem.activeOrderGoodsCouponDTO.goodsType==='outCoupon' && 
                                    <View style={[st.card]}>
                                        <JDText style={[st.card_txt]}>卡密：{couponItem.activeOrderGoodsCouponDTO.goodsRedeemCode}</JDText>
                                        <JDTouchable onPress={() => this._copyCard(couponItem.activeOrderGoodsCouponDTO.goodsRedeemCode)}>
                                            <View style={[st.copy_btn]}><JDText style={[st.copy_txt]}>复制</JDText></View>
                                        </JDTouchable>
                                    </View>
                                }
                            </View>
                        )
                    })
                }
                
                {/* <View style={[st.coupon]}>
                    <View style={[st.coupon_item]}>
                        <View style={[st.coupon_l]}>
                            <View style={[st.zeng]}><JDText style={[st.z_txt]}>购</JDText></View>
                            <JDText style={[st.coupon_txt]}>XXX优惠券</JDText>
                            <JDTouchable onPress={() => this._openDialog()}><JDImage style={[st.icon]} source={img.coupon_detail_icon} /></JDTouchable>
                        </View>
                        <View><JDText style={[st.money_txt]}>1元</JDText></View>
                    </View>
                    <View style={[st.card]}>
                        <JDText style={[st.card_txt]}>卡密：7500 4982 5627 68</JDText>
                        <JDTouchable onPress={() => this._copyCard('7500 4982 5627 68')}>
                            <View style={[st.copy_btn]}><JDText style={[st.copy_txt]}>复制</JDText></View>
                        </JDTouchable>
                    </View>
                </View> */}
                {<CouponDetail isShow={isDetailShow} currentCoupon={currentCoupon} closeDialog={()=>this._closeDialog()} />}
            </View>
        )
    }
}
const img = {
    coupon_detail_icon: require('../img/coupon_detail_icon.png')
};
const st = StyleSheet.create({
    box: {
        marginBottom: pt(9),
        backgroundColor: '#fff'
    },
    title: {
        paddingTop: pt(9),
        paddingBottom: pt(9),
        paddingLeft: pt(12),
        borderBottomColor: '#E6E6E6',
        borderBottomWidth: px(1)
    },
    t_txt: {
        color: '#333',
        fontSize: pt(15)
    },
    coupon_item: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingTop: pt(10),
        paddingBottom: pt(10)
    },
    coupon_l: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    zeng: {
        // display: 'inline-block',
        marginRight: pt(6),
        width:pt(18),
        height:pt(18),
        justifyContent:'center',
        alignItems:'center',
        borderColor: '#AAAAAA',
        borderWidth: px(1),
        borderRadius: pt(2)
    },
    z_txt: {
        color: '#aaa',
        fontSize: pt(15)
    },
    coupon_txt: {
        color: '#333',
        fontSize: pt(15)
    },
    money_txt: {
        color: "#333",
        fontSize: pt(15)
    },
    icon: {
        marginLeft: pt(6),
        width: pt(14),
        height: pt(14)
    },
    card: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginLeft: pt(27),
        paddingBottom: pt(12),
        alignItems: 'center'
    },
    card_txt: {
        color: '#aaa',
        fontSize: pt(12)
    },
    copy_btn: {
        borderColor: "#aaa",
        borderWidth: px(1),
        paddingTop: pt(3),
        paddingBottom: pt(3),
        paddingLeft: pt(12),
        paddingRight: pt(12),
        borderRadius: pt(2)
    },
    copy_txt: {
        color: "#333",
        fontSize: pt(12)
    }
});
export default OrderCoupon;